import React from "react"
import { Popover } from "antd"

export default {
    tableStatus(audit, audit_name,vname, time, detail) {
        if (audit === '0') {
            return (<span>{audit_name}</span>)
        } else {
            return (
                <span>
                    <div>{vname || ' - '}</div>
                    <div>
                        <span>{audit_name}</span>
                        {
                            audit === '2' ? (
                                <Popover content={<div style={{ maxWidth: 200, wordBreak: 'break-all' }}>{detail || '无记录'}</div>} title={<div style={{ textAlign: 'center' }}>不通过原因</div>}>
                                    <span style={{ color: '#1890ff', marginLeft: 10, cursor: 'pointer' }}>查看原因</span>
                                </Popover>
                            ) : null
                        }
                    </div>
                    <div>{time}</div>
                </span>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/routes/review/common3.js